import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'anthropic',
  version: '1.0.0',
  properties: [
    // ==================================================================
    // CREDENTIALS
    // ==================================================================
    {
      key: 'credentialId',
      label: 'API Credential',
      type: 'credential',
      required: true,
      typeOptions: {
        credentialType: 'claude',
      },
      description: 'Anthropic API credentials',
    },
    
    // ==================================================================
    // MODEL CONFIGURATION
    // ==================================================================
    {
      key: 'model',
      label: 'Model',
      type: 'options',
      required: true,
      default: 'claude-haiku-4-5-20251001',
      options: [
        // Claude 4.5 Family (Latest)
        { value: 'claude-opus-4-5-20251101', name: 'Claude Opus 4.5 - Most Capable' },
        { value: 'claude-sonnet-4-5-20250929', name: 'Claude Sonnet 4.5 - Smart & Efficient' },
        { value: 'claude-haiku-4-5-20251001', name: 'Claude Haiku 4.5 - Fast & Compact (Recommended)' },
        // Claude 3.5 Family
        { value: 'claude-3-5-sonnet-20241022', name: 'Claude 3.5 Sonnet (Latest)' },
        { value: 'claude-3-5-sonnet-20240620', name: 'Claude 3.5 Sonnet (Original)' },
        { value: 'claude-3-5-haiku-20241022', name: 'Claude 3.5 Haiku' },
        // Claude 3 Family (Legacy)
        { value: 'claude-3-opus-20240229', name: 'Claude 3 Opus (Legacy)' },
        { value: 'claude-3-sonnet-20240229', name: 'Claude 3 Sonnet (Legacy)' },
        { value: 'claude-3-haiku-20240307', name: 'Claude 3 Haiku (Legacy)' },
      ],
      description: 'Which Claude model to use',
    },
    
    // ==================================================================
    // LLM PARAMETERS (Optional - leave empty to use defaults)
    // ==================================================================
    {
      key: 'temperature',
      label: 'Sampling Temperature',
      type: 'string',
      required: false,
      placeholder: 'e.g., 0.7',
      description: 'Controls randomness (0 = deterministic, 1 = creative)',
    },
    {
      key: 'maxTokens',
      label: 'Max Tokens',
      type: 'string',
      required: false,
      placeholder: 'e.g., 4096',
      description: 'Maximum tokens in the response',
    },
    {
      key: 'topP',
      label: 'Top P',
      type: 'string',
      required: false,
      placeholder: 'e.g., 1.0',
      description: 'Nucleus sampling threshold',
    },
    {
      key: 'topK',
      label: 'Top K',
      type: 'string',
      required: false,
      placeholder: 'e.g., 40',
      description: 'Only sample from the top K options for each subsequent token',
    },
    {
      key: 'thinkingEnabled',
      label: 'Enable Thinking',
      type: 'boolean',
      required: false,
      description: 'Enable extended thinking for complex reasoning tasks (Claude 4+ models only)',
      default: false,
    },
    {
      key: 'thinkingBudget',
      label: 'Thinking Budget',
      type: 'number',
      required: false,
      typeOptions: {
        minValue: 1000,
        maxValue: 100000,
      },
      description: 'Maximum tokens for thinking (extended thinking only)',
      displayOptions: {
        show: {
          thinkingEnabled: [true],
        },
      },
    },
  ],
};

export default schema;
